/**
 * useOpenhome
 * 
 * @Author: Focci
 * @Date: 2024-04-28 14:26:56
 * @Last Modified by: Focci
 * @Last Modified time: 2024-04-28 14:26:56
 */

// import PropTypes from 'prop-types'
import useApp from '@hook/useApp'
import useLogin from '@hook/useLogin'
import useTracking from '@hook/useTracking'
import { formatDate } from '@lib/datetime'
import { fetchPost, fetchProxy } from '@lib/fetch/client'
import { myAppointments } from '@lib/route/profile'
import { houseToGta, isAU } from '@lib/utils'
import { clone, isArray } from 'lodash-es'
import { useLocale } from 'next-intl'
import { useCallback, useMemo, useState } from 'react'

export default function useOpenhome({
  house,
  data,
  type = 2
}) {
  const { houseId, suburbId } = house
  const isAuction = type === 3

  const locale = useLocale()
  const { pushTrack, pushTrackListing } = useTracking()
  const { user, openSigninDialog } = useLogin()
  const { isInitial, openhomes, setOpenhomes } = useApp()

  const [loading, setLoading] = useState(false)

  // 是否已添加到行程
  const added = useMemo(() => {
    const tmp = openhomes[houseId]
    const label = `${type}_${data.time_start}`
    return isArray(tmp) && tmp.indexOf(label) > -1
  }, [data.time_start, houseId, openhomes, type])

  // 添加看房行程
  const handleClick = useCallback(async (successCallback = () => {}) => {
    const { time_start: timeStart, time_end: timeEnd } = data
    if (!user) {
      return openSigninDialog()
    }

    // 如果已经添加，跳转到个人中心
    if (added) {
      return window.open(
        `${myAppointments(locale)}?date=${formatDate(timeStart, 'YYYY-MM-DD')}`,
        '_blank'
      )
    }
    
    const eventName = isAuction ? 'add_calendar_auction' : 'add_calendar_openhome'
    // tracking
    pushTrackListing(eventName, house)
    pushTrack(eventName, { houseId, suburbId }, { once: true })

    if(isAU) {
      pushTrack(isAuction ? 'homely_auction_save' : 'homely_inspection_save', houseToGta(house))
    }

    const param = {
      email: user.email || '',
      houseId,
      mobileNumber: user?.mobile_number || '',
      name: user.nickname,
      start: timeStart,
      type,
    }

    !isAuction && (param.end = timeEnd)

    await fetchProxy(
      fetchPost('user/appointment', param),
      setLoading
    )

    const successEventName = isAuction ? 'add_auction_success' : 'add_openhome_success'
    // tracking
    pushTrackListing(successEventName, house)
    pushTrack(successEventName, { houseId, suburbId }, { once: true })

    // 更改已添加的状态
    setOpenhomes((prev) => {
      const tmp = clone(prev)
      const val = `${type}_${timeStart}`
      tmp[houseId] = isArray(tmp[houseId]) ? tmp[houseId] : []

      if (tmp[houseId].indexOf(val) === -1) {
        tmp[houseId].push(val)
      }

      return tmp
    })

    successCallback({ data, type, house })
    return null
  }, [
    data, user, added, pushTrack, pushTrackListing, isAuction, houseId, house,
    type, setOpenhomes, openSigninDialog, suburbId, locale
  ])

  const isLoading = useMemo(() => (isInitial || loading), [isInitial, loading])

  return {
    handleClick,
    isAuction,
    added,
    isLoading
  }
}

// useOpenhome.propTypes = {
//   className: PropTypes.string,
// }
